<template>
  <div class="row">
    <div v-if="address && address.fields.length > 0" class="col-12">
      <p v-if="showTitle" class="q-subtitle">
        {{ address.title }}
      </p>
      <div class="row q-col-gutter-sm">
        <div v-for="(field, index) in address.fields" :key="field.label" class="col-12">
          <q-input
            v-if="field.type === 'input'"
            v-model.trim="field.value"
            :class="{ required: field.required }"
            hide-bottom-space
            bottom-slots
            dense
            outlined
            :label="field.label"
            :error="field.required ? $v.address.fields.$each[index].value.$invalid : false"
            error-message="Required Field"
            :hint="field.helper !== '' ? field.helper : ''"
            class="text-capitalize,q-mb-sm"
            clearable
            @input="$v.address.fields.$each[index].value.$touch"
          />
          <q-select
            v-if="field.type === 'select' || (field.type === 'custom-select' && field.type !== 'masters-select')"
            v-model="field.value"
            :class="{ required: field.required }"
            bottom-slots
            :label="field.label"
            hide-bottom-space
            options-dense
            dense
            emit-value
            map-options
            outlined
            clearable
            :error="field.required ? $v.address.fields.$each[index].value.$invalid : false"
            error-message="Required Field"
            :hint="field.helper !== '' ? field.helper : ''"
            :options="setDynamicFieldKeyOptionsData(address, field.key, optionFilters)"
            @input="fieldOnChange(address, field.key, field.value, field.trigger)"
          />
          <q-select
            v-if="field.type === 'masters-select'"
            v-model="field.value"
            :class="{ required: field.required }"
            :label="field.label"
            hide-bottom-space
            bottom-slots
            options-dense
            dense
            emit-value
            map-options
            outlined
            clearable
            :disable="true"
            :error="field.required ? $v.address.fields.$each[index].value.$invalid : false"
            error-message="Required Field"
            :hint="field.helper !== '' ? field.helper : ''"
            :readonly="!address.title.includes('Custom')"
            :options="setDynamicFieldKeyOptionsData(address, field.key, optionFilters)"
            @input="$v.address.fields.$each[index].value.$touch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import addressMixinNew from 'src/application/global/mixins/addressMixinNew'
import { debounce } from 'quasar'
import _ from 'lodash'
export default {
  name: 'ShippingAddress',
  mixins: [addressMixinNew],
  props: {
    countryId: { type: Number },
    address: {
      type: [Object, Boolean],
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    optionFilters: {
      type: Object,
      default: () => ({}),
    },
    useInBuiltFieldChange: {
      type: Boolean,
      default: false,
    },
    loadDefaultAddress: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    address: {
      fields: {
        $each: {
          value: {
            check(val, elm) {
              if (elm.required || elm.min) {
                if (elm.value === '' || elm.value === null) {
                  return false
                }
              }
              return true
            },
          },
        },
      },
    },
  },
  watch: {
    async countryId() {
      await this.initAddress()
    },
    loadDefaultAddress: {
      async handler() {
        await this.initAddress()
      },
      immediate: true,
      deep: true,
    },
    '$v.$error': {
      handler(to) {
        // Experimental feature
        this.$emit('errorStatus', to)
      },
      deep: true,
    },
  },
  mounted() {
    this.initAddress = debounce(this.initAddress, this.appSettings.debounceDelay)
  },
  methods: {
    async initAddress() {
      if (this.loadDefaultAddress && this.countryId && this.$helpers.getValue(this.address, 'fields', []).length < 1) {
        await this.setAddressFormat(this.address, this.countryId)
        this.address.fields = this.sortDynamicFieldsCountryStateCityTop(this.address.fields || [])
      }
      if (this.address.fields.length > 0) {
        await this.initializeAddresses([this.address])
      }
    },
    async fieldOnChange(address, key, value, triggerField = false) {
      this.$emit('fieldOnChange', { address: address, key: key, value: value, triggerField: triggerField })
      if (this.useInBuiltFieldChange) {
        if (key === 'states') {
          await this.setCities(value)
        }
      }
    },
    async validate() {
      // Validating component
      return await new Promise(resolve => {
        this.$v.$touch()
        resolve(this.$v.$error)
      })
    },
  },
}
</script>
